import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OfflineBoltRoundedIcon from '@mui/icons-material/OfflineBoltRounded';
import verifiedIcon from '@src/assets/icons/verified-rounded.svg';
import KeyboardDoubleArrowRightRoundedIcon from '@src/assets/icons/KeyboardDoubleArrowRightRounded.svg';
import MaleVoiceIcon from '@src/assets/images/male-voice.png';
import { COLOR } from '@src/styles/color';
import { StyledDemoCloningResults, StyledArrowIcon } from './index.style';
import DemoCloningResultItem from './DemoCloningResultItem';

const DemoCloningResults = () => {
  const { t } = useTranslation();
  const audioRef = useRef(null);

  const [currentPlayingVoiceType, setCurrentPlayingVoiceType] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const demoCloningResults = [
    {
      voiceName: 'Nhật Minh',
      voiceAvatar: MaleVoiceIcon,
      voiceType: t('originalVoice'),
      audioSrc:
        'https://vbee-aivoice.s3.ap-southeast-1.amazonaws.com/voice-cloning/sample-audios/male-root-enhanced-v2.wav',
    },
    {
      voiceName: 'Nhật Minh',
      voiceAvatar: MaleVoiceIcon,
      voiceType: t('instantVoiceCloningType'),
      badgeIcon: (
        <OfflineBoltRoundedIcon
          sx={{
            width: '20px',
            height: '20px',
            backgroundColor: `${COLOR.whiteV2.default}`,
            borderRadius: '50%',
          }}
        />
      ),
      audioSrc:
        'https://vbee-aivoice.s3.ap-southeast-1.amazonaws.com/voice-cloning/sample-audios/male-zeroshot-1x-enhanced-v2.wav',
    },
    {
      voiceName: 'Nhật Minh',
      voiceAvatar: MaleVoiceIcon,
      voiceType: t('proVoiceCloningType'),
      badgeIcon: (
        <img src={verifiedIcon} alt="badge" className="verified-icon" />
      ),
      audioSrc:
        'https://vbee-aivoice.s3.ap-southeast-1.amazonaws.com/voice-cloning/sample-audios/male-clone-enhanced-v2.wav',
    },
  ];

  const handlePlayVoiceType = (audioSrc, voiceType) => {
    if (currentPlayingVoiceType === voiceType) {
      if (isPlaying) {
        setIsPlaying(false);
        audioRef.current.pause();
      } else {
        setIsPlaying(true);
        audioRef.current.play();
      }
      return;
    }

    setCurrentPlayingVoiceType(voiceType);
    setIsPlaying(true);
    audioRef.current.src = audioSrc;
    audioRef.current.load();
    audioRef.current.play();
  };

  const handleAudioEnded = () => {
    setIsPlaying(false);
    setCurrentPlayingVoiceType(null);
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
  };

  const renderDemoCloningResults = () =>
    demoCloningResults.map((result, index) => (
      <React.Fragment key={result.voiceType}>
        <DemoCloningResultItem
          badgeIcon={result.badgeIcon}
          voiceName={result.voiceName}
          voiceType={result.voiceType}
          voiceAvatar={result.voiceAvatar}
          onPlayingVoiceType={() =>
            handlePlayVoiceType(result.audioSrc, result.voiceType)
          }
          isPlaying={isPlaying}
          currentPlayingVoiceType={currentPlayingVoiceType}
        />
        {index !== demoCloningResults.length - 1 && (
          <StyledArrowIcon>
            <div className="icon-wrapper">
              <img src={KeyboardDoubleArrowRightRoundedIcon} alt="arrow" />
            </div>
          </StyledArrowIcon>
        )}
      </React.Fragment>
    ));

  return (
    <StyledDemoCloningResults>
      {renderDemoCloningResults()}
      <audio
        ref={audioRef}
        onEnded={handleAudioEnded}
        style={{ display: 'none' }}
      >
        <track kind="captions" />
      </audio>
    </StyledDemoCloningResults>
  );
};

export default DemoCloningResults;
